import { httpsCallable, type HttpsCallableResult } from "firebase/functions";
import { fns } from "./firebase";
import type { Source } from "./types";

interface TriggerSubmitRequest {
  sessionId: string;
  source: Source;
  qrToken?: string;
  /** Code serveur exigé quand `settings.waiterConfirm` est vrai. */
  waiterPassword?: string;
}
interface TriggerSubmitResponse {
  pendingId: string;
  expiresAt: number;
}

interface CancelSubmitRequest {
  sessionId: string;
  pendingId: string;
}
type CancelSubmitResponse =
  | { cancelled: true }
  | { cancelled: false; reason: "too_late" };

interface RecoverRequest {
  sessionId: string;
  pendingId: string;
}
interface RecoverResponse {
  recovered: "kitchen_received" | "draft_restored" | "noop";
}

const _trigger = httpsCallable<TriggerSubmitRequest, TriggerSubmitResponse>(fns, "qrTriggerSubmit");
const _cancel = httpsCallable<CancelSubmitRequest, CancelSubmitResponse>(fns, "qrCancelSubmit");
const _recover = httpsCallable<RecoverRequest, RecoverResponse>(fns, "qrRecoverStuckSession");

export const callTriggerSubmit = (req: TriggerSubmitRequest): Promise<HttpsCallableResult<TriggerSubmitResponse>> => _trigger(req);
export const callCancelSubmit = (req: CancelSubmitRequest): Promise<HttpsCallableResult<CancelSubmitResponse>> => _cancel(req);
export const callRecoverStuck = (req: RecoverRequest): Promise<HttpsCallableResult<RecoverResponse>> => _recover(req);
